export default __webpack_public_path__ + "static/media/Gallery13.7796e644.jpg";